<template>
  <section class="p-0">
    <div class="page-wrapper">
      <div class="error-wrapper">
        <div class="container">
          <div class="col-md-6 offset-md-3">
            <div class="login-form">
              <form class="default-form">
                <h2 class="d-none d-lg-block pb-5">
                  {{ _T('Change your password') }}
                </h2>
                <div class="form-group">
                  <label>{{ _T('Enter new password') }}</label>
                  <input
                    required
                    v-model="password"
                    type="password"
                    class="form-control"
                    :placeholder="_T('Enter new password')"
                    :class="{
                      'border rounded border-danger': errors.password,
                    }"
                  />
                  <span
                    v-if="errors.password"
                    class="validation-error d-block pt-1"
                  >
                    {{ errors.password }}
                  </span>
                </div>
                <div class="form-group">
                  <label>{{ _T('Confirm new password') }}</label>
                  <input
                    required
                    v-model="confirm_password"
                    type="password"
                    class="form-control"
                    :placeholder="_T('Confirm new password')"
                    :class="{
                      'border rounded border-danger': errors.confirm_password,
                    }"
                  />
                  <span
                    v-if="errors.confirm_password"
                    class="validation-error d-block pt-1"
                  >
                    {{ errors.confirm_password }}
                  </span>
                </div>
                <progress-bar
                  v-if="processInProgress(process)"
                  :btn-large="true"
                  :ui-block="true"
                  >{{ _T('Changing') }}
                </progress-bar>
                <button
                  v-else
                  @click.prevent="validateForm()"
                  class="btn btn-solid btn-block"
                >
                  <span>{{ _T('Change') }}</span>
                </button>
                <div
                  v-if="login_fail_message || login_success_message"
                  class="alert fade show mt-3"
                  :class="
                    login_fail_message
                      ? 'alert-danger'
                      : login_success_message
                      ? 'alert-success'
                      : ''
                  "
                  role="alert"
                >
                  {{
                    login_fail_message
                      ? login_fail_message
                      : login_success_message
                      ? login_success_message
                      : ''
                  }}
                </div>
              </form>
              <!-- <div class="d-block pt-5">
                <router-link :to="{ name: 'login' }">
                  {{ _T('Log In here if you have password') }}
                </router-link>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Elements/ProgressBar'

export default {
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirm_password: '',
      request_message: '',
      token: '',
      process: 'reset-password',
      errors: {},
    }
  },
  computed: {
    ...mapGetters([
      'login_success_message',
      'login_fail_message',
      'login_in_progress',
      '_T',
      'processInProgress',
    ]),
  },
  components: {
    ProgressBar,
  },
  methods: {
    validateForm() {
      this.errors = {}
      this.errors.count = 0
      if (!this.password) {
        this.errors.password = this._T('Password is required')
        this.errors.count = 1
      }
      if (!this.confirm_password) {
        this.errors.confirm_password = this._T('Confirm password is required')
        this.errors.count = 1
      }
      if (this.password != this.confirm_password) {
        this.errors.confirm_password = this._T('Passwords should match')
        this.errors.count = 1
      }
      if (this.errors.count === 0) {
        this.reset_password()
      }
    },
    nextPage(){
        this.$router.replace({ name: 'home' });
    },
    reset_password() {
      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        let password = this.password
        let confirm_password = this.confirm_password
        let token = this.token
        this.$store
          .dispatch('new_password_confirm', {
            password,
            confirm_password,
            token,
          })
          .then(() => {
            this.$store.dispatch('showNotification', {
              text: this._T('Password Reset Successfully'),
              status: 'success',
            })
            setTimeout(this.nextPage,1500);
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
  },
  mounted() {
    this.token = this.$route.params.token
  },
}
</script>

<style lang="scss">
.error-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 197px);
}
@media (max-width: 767px) {
  .error-wrapper {
    height: calc(100vh - 260px);
  }
}
</style>
